/**
 * Layout component
 */

import React from 'react';

//Components
import Header from './header';
import Footer from './footer';

const Layout = ({ lang, children }) => {
  return (
    <div className="wrapper-holder">
      <div className="wrapper">
        <Header lang={lang} />

        <main className="main">{children}</main>

        <Footer lang={lang} />

        <form name="contact" data-netlify="true" className="d-none">
          <input type="hidden" name="form-name" value="contact" />
        </form>
      </div>
    </div>
  );
};

export default Layout;
